

















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class CheckBig extends Vue {
  @Prop({ default: '40' }) readonly width?: string;
  @Prop({ default: '40' }) readonly height?: string;
  @Prop({ default: '#0B874C' }) readonly fill?: string;
}
